<template>
    <div
    class="modal right fade trader-info c-offer-modal"
    id="trader-info"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"       
    >
    <div class="modal-dialog modal-dialog-centered modal-lg " role="document" @click="showDropdown = false">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">{{mode}} HOLDING</h5>
            <button type="button" class="close"  @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="bg-secondary">
                <form  @submit.prevent="">
                    <div class="form-row">
                        <div class="form-group">
                            <label for="inputEmail4">SEARCH CUSIP</label>
                            <input
                                type="text"
                                v-model.trim="searchValue"
                                class="form-control"
                                id="account"
                                maxlength="9"
                                placeholder="Enter Cusip"
                                :disabled="mode == 'EDIT'"
                                @keypress="isAlphanumeric($event)" 
                                
                            />
                            <div v-if="mode == 'ADD'" class="form-group-append">
                            <button @click="searchCusip()" class="btn ibtn" type="button"><i class="fas fa-search active cursor-pointer" aria-hidden="true"></i></button>
                            </div>
                            
                        </div>
                        <div class="form-group">
                            <label for="inputEmail4">MATURITY DATE</label>
                            <div class="cusip-info"> {{selectedCusip.maturityDate ? moment(selectedCusip.maturityDate).format("MM/DD/YYYY") : "N/A"}}</div>

                        </div>
                        <div class="form-group">
                            <label for="inputEmail4">CALL DATE</label>
                            <div class="cusip-info">{{selectedCusip.callDate ? moment(selectedCusip.callDate).format("MM/DD/YYYY") : "N/A"}}</div>
                        </div>
                        <div class="form-group">
                            <label for="inputEmail4">COUPON</label>
                            <div class="cusip-info">{{selectedCusip.coupon | percent(3)}}</div>
                        </div>
                        <div class="form-group">
                            <label for="inputEmail4">STATE/INSURER</label>
                            <div class="cusip-info">{{getStateName(selectedCusip.stateId)}} / {{selectedCusip.bondInsurer ? selectedCusip.bondInsurer  : 'N/A'}}</div>
                        </div>
                    </div>
                </form>
            </div>     
            <form class="invt">
                <div class="form-row">
                    <div class="form-group col-md-4 required">
                        <label for="inputEmail4">Account</label>
                        <div class="dropdown" v-on:click.stop.prevent="">
                            <input v-if="Object.keys(selectedAccount).length === 0" ref="dropdowninput" @click="showList()" v-model.trim="inputValue" class="dropdown-input w-100" type="text" placeholder="Select or Search Account" />
                            <div v-else @click="resetSelection" class="dropdown-selected">
                                {{ selectedAccount.customerName}} - {{ selectedAccount.account}}
                            </div>
                            <div v-if="showDropdown && !accountListApiLoaded" class="dropdown-list loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                            <div v-show="showDropdown && accountListApiLoaded" class="dropdown-list">
                                <div @click="selectItem(item)" v-show="itemVisible(item)" v-for="(item , i) in accountList" :key="'A'+ i" class="dropdown-item">
                                {{ item.customerName}} - {{ item.account}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group col-md-6 required">
                        <label for="inputLast">Quantity</label>
                        <input 
                            type="text" 
                            class="form-control" 
                            id="inputLast" 
                            placeholder="Quantity"  
                            v-model.number="selectedInventory.quantity" 
                            maxlength="8" 
                            @keypress="isQuantity($event)"
                        >
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-4 required">
                        <label for="inputLast">Bought Date</label>
                        <datepicker
                        v-if="mode == 'ADD'"  
                        v-model="selectedInventory.boughtDate" 
                        placeholder="mm/dd/yyyy" 
                        typeable 
                        name="callDate" 
                        format="MM/dd/yyyy" 
                        :clear-button="true" 
                        :calendar-button="true" 
                        :disabledDates="disabledDates"
                        calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker> 
                        <datepicker
                        v-if="mode == 'EDIT'"  
                        v-model="selectedInventory.boughtDate" 
                        placeholder="mm/dd/yyyy" 
                        typeable 
                        name="callDate" 
                        format="MM/dd/yyyy" 
                        :clear-button="true" 
                        :calendar-button="true"
                        :disabledDates="disabledDates"
                        calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker> 
                    </div>    
                    <div class="form-group col-md-4 required">
                        <label for="inputLocation">Cost</label>
                        <input type="number" class="form-control" placeholder="Cost"  v-model.number="selectedInventory.cost">
                    </div>
                    <div class="form-group col-md-4">
                        <label for="inputLocation">ClosingPx</label>
                        <input type="number" class="form-control" placeholder="ClosingPx"  v-model.number="selectedInventory.closingPx">
                    </div>
                    <div class="form-group col-md-4">
                        <label for="inputLocation">Assigned To</label>
                        <multiselect 
                            v-model="filterUser" 
                            placeholder="Select user" 
                            label="firstName" 
                            track-by="id"
                            :options="userList"  
                            :limit="3"  ></multiselect>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-12">
                        <label for="inputLocation">Notes</label>
                        <textarea class="form-control" style="height: auto;" v-model="selectedInventory.notes"  rows="4" cols="50" ></textarea>

                    </div>
                    
                </div>  
                <div class="form-row" v-if="mode == 'EDIT'">
                    <div class="form-group col-md-6">
                        <label for="inputLocation">Assigned Quantity</label>
                        <input :disabled="true" type="number" class="form-control"  v-model.number="selectedInventory.assignedQuantity">
                    </div>
                    
                </div>    
                <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                <p v-if="errors.length">
                    <ul>
                    <li class="alert alert-danger" role="alert" v-for="error in errors" v-bind:key="error">{{ error }}</li>
                    </ul>
                </p>
                <p v-if="isUploadInProgress()">
                    <ul>
                    <li class="alert alert-danger" role="alert">
                        Holding upload is currently in progress. Please try again once it’s complete.
                    </li>
                    </ul>
                </p>
                <div class="modal-footer bid">
                    <button type="button" class="btn btn-secondary"  @click="$emit('close')">Close</button>
                    <button :disabled="isUploadInProgress()" v-if="mode == 'ADD'" type="button" class="btn btn-primary" @click="addInventory()">ADD HOLDING</button>
                    <button :disabled="isUploadInProgress()" v-if="mode == 'EDIT'" type="button" class="btn btn-primary" @click="checkOfferExist(selectedInventory)">UPDATE HOLDING</button>
                </div>
            </form>
        </div>
        </div>
    </div>
    </div>
</template>

<script>
    import authService from "@/authService";
    import config from "@/config";
    import stateConstants from "@/stateConstants";
    import Datepicker from 'vuejs-datepicker';

    export default {
        name: 'inventoryAddmodal',
        components :{
            Datepicker
        },
        props: ['selectedInventory','mode'],
        data() {
            return {
                loading : false,
                errors: [],
                selectedCusip : {},
                stateConstants: stateConstants,
                searchValue : "",
                selectedAccount: {},
                showDropdown : false,
                accountListApiLoaded : false,
                inputValue: '',
                accountList: [],
                selectedAccountName : "",
                disabledDates: {
                    from: new Date()
                },
                userList : [],
                filterUser : null,

            };
        },
        methods: {   
            getUserList(){             
                const auth = {
                    headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
                };
                this.$http
                    .get(
                    config.baseUrlBidSide +
                        "/user/list?page=1&size=1000&search=&status=ACTIVE&sortColumn=firstName&sortOrder=ASC&group=",
                        auth
                    )
                    .then(result => {
                    result.data.content.forEach(user =>{
                        user.firstName =  user.firstName+" "+user.lastName;
                        user.isRestricted = false;
                        if(user.userGroups.length === 1){
                            if(user.userGroups[0] == "Drl-Client" || user.userGroups[0] == "Drl-Guest"){
                                user.isRestricted = true;
                            }
                        }
                    });
                    this.userList = result.data.content.filter(user => !user.isRestricted);

                    this.filterUser = this.userList.find((user) => user.id == this.selectedInventory.assignedTo)
                    
                    })
                    .catch(e => {
                    console.log(e);
                    });
            },
            addInventory(){
                let isValid = this.checkForm();
                if (isValid) {
                    this.loading = true;
                    var addData = {};
                    addData.accountMappingId = this.selectedAccount.accountMappingId;
                    addData.cusipId = this.selectedCusip.id;
                    addData.quantity = this.selectedInventory.quantity;
                    addData.boughtDate = this.selectedInventory.boughtDate ? this.moment(this.selectedInventory.boughtDate).format("MM/DD/YYYY") : null;
                    addData.cost = this.selectedInventory.cost;
                    addData.notes = this.selectedInventory.notes;
                    addData.closingPx = this.selectedInventory.closingPx;
                    addData.assignedTo = this.filterUser ? this.filterUser.id : "";
                    const auth = {
                        headers: { 'org-token' : authService.getOrgToken()  }
                    };
                    this.$http
                    .post(config.baseUrlBidSide + "/inventory", addData, auth)
                    .then(() => {
                        this.$alert("Holding Added","","success")
                        this.loading = false;
                        this.$root.$emit("invadded");              
                        this.$emit('close');               
                    })
                    .catch(() => {
                        this.loading = false;              
                    });
                }
            },
            checkOfferExist(inv){
                if(this.selectedInventory.assignedQuantity > this.selectedInventory.quantity ){
                    this.$alert("Quantity cannot be less than assigned quantity","","error");
                    return true;
                }
                this.loading = true;
                const auth = {
                    headers: { 'org-token' : authService.getOrgToken()  }
                };
                this.$http
                .get(config.baseUrlBidSide + "/inventory/is-offer-exist?inventoryId="+inv.id,auth)
                .then((result) => {
                    this.loading = false;
                    if(result.data.isOfferExist){
                        this.$confirm("There is an existing offer for this Holding","","question").then(() => {
                            this.updateInventory()
                        });
                    }
                    else if(result.data.isBidWantedExist){
                        this.$confirm("There is an existing bid wanted for this Holding").then(() => {
                            this.updateInventory()
                        });
                    }else{
                        this.updateInventory()
                    }
                    // if(result.data.isOfferExist){
                    //     this.$alert("Can't delete or update. There is an existing offer for this Holding","","warning")
                    // }else{
                    //     if(this.selectedInventory.assignedQuantity > this.selectedInventory.quantity ){
                    //         this.$alert("Quantity cannot be less than assigned quantity","","error");
                    //     }else{
                    //         this.updateInventory()
                    //     }
                    // }              
                    // console.log(result.data)         
                })
                .catch(() => {
                    this.loading = false;              
                });
            },
            updateInventory(){
                let isValid = this.checkForm();
                if (isValid) {
                    this.loading = true;
                    var addData = {};
                    addData.inventoryId = this.selectedInventory.id
                    addData.accountMappingId = this.selectedAccount.accountMappingId;
                    addData.cusipId = this.selectedCusip.id;
                    addData.quantity = this.selectedInventory.quantity;
                    addData.boughtDate = this.selectedInventory.boughtDate ? this.moment(this.selectedInventory.boughtDate).format("MM/DD/YYYY") : null;
                    addData.cost = this.selectedInventory.cost;
                    addData.notes = this.selectedInventory.notes;
                    addData.closingPx = this.selectedInventory.closingPx;
                    addData.assignedTo = this.filterUser ? this.filterUser.id : ""
                    const auth = {
                        headers: { 'org-token' : authService.getOrgToken()  }
                    };
                    this.$http
                    .put(config.baseUrlBidSide + "/inventory/edit", addData, auth)
                    .then(() => {
                        this.$alert("Holding Updated","","success")
                        this.loading = false;              
                        this.$emit('close'); 
                        this.$root.$emit("invadded");              

                    })
                    .catch(() => {
                        this.loading = false;              
                    });
                }

            },
            checkForm(){
                this.errors = [];
                if (!this.selectedCusip.id) {
                    this.errors.push("Cusip is required.");
                    return false;
                }
                if (!this.selectedAccount.accountMappingId) {
                    this.errors.push("Account is required.");
                    return false;
                }
                 if (!this.selectedInventory.quantity) {
                    this.errors.push("Quantity is required.");
                    return false;
                }
                if (!this.selectedInventory.boughtDate) {
                    this.errors.push("Bought date is required.");
                    return false;
                }
                if (!this.selectedInventory.cost) {
                    this.errors.push("Cost is required.");
                    return false;
                }
                return true
            },
            searchCusip(){
                if(this.searchValue.length != 9){
                    this.$alert("Enter 9 digit characters long CUSIP","","error");
                return
                }
                this.loading = true;
                const auth = {
                    headers: { 'org-token' : authService.getOrgToken() }
                };
                this.$http
                .get(
                config.baseUrlBidSide +
                    "/cusip/list?page=1&status=ACTIVE,BLOCKED&sortColumn=cusip&sortOrder=ASC&type=OFFER"+
                    "&cusip=" +
                    this.searchValue,
                    auth
                )
                .then(result => {
                if(result.data.content.length > 0){               
                    this.selectedCusip = result.data.content[0]
                }else{
                    this.$alert("Cusip not found")
                }
                this.loading = false;
                })

            },
            getStateName(id){
                return id ? this.stateConstants.find(x => x.id === id).short : 'N/A';
            },
            itemVisible (item) {
                let currentName = item.customerName.toLowerCase()+'-'+item.account.toLowerCase();
                let currentInput = this.inputValue.toLowerCase()
                return currentName.includes(currentInput)
                
            },
            showList(){
                this.showDropdown = true
            },
            hideList(){
                this.showDropdown = false
            },
            resetSelection () {
                //if(this.mode == 'ADD'){
                    this.selectedAccount = {};
                    this.showDropdown = true;
                    this.$nextTick( () => this.$refs.dropdowninput.focus() )
                //}
                
            },
            selectItem (theItem) {
                this.selectedAccount = theItem 
                this.inputValue = ''
                this.showDropdown = false;
                console.log('on-item-selected', theItem);
            },
            getAllAccountList(){
                const auth = {
                    headers: { 'org-token' : authService.getOrgToken() }
                };
                this.$http
                .get(
                config.baseUrlBidSide +
                    "/inventory/account-map-list",
                    auth
                )
                .then(result => {
                this.accountList = [];
                this.accountList = result.data
                this.accountListApiLoaded = true;
                if(this.mode == 'EDIT'){
                   let inv =  this.accountList.find(o => o.accountMappingId === this.selectedInventory.accountMappingId);
                   if(inv){
                       this.selectItem(inv)
                   }
                }
                })
            },

        },
        mounted(){
            console.log(this.selectedInventory,this.mode);
            if(this.mode == 'ADD'){
                //this.selectedInventory = {}
            }else{
                this.searchValue = this.selectedInventory.cusipVal;
                this.searchCusip();
            }
            this.getAllAccountList();
            this.getUserList()
        }
    };
    </script>
    <style  scoped>
    .account-disabled{
        background:#d9d9d9 !important;
    }
    </style>